import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);

// ── Service Worker (PWA · caché fresca) ─────────────────────────────────────
// Registramos /sw.js (network-first).
//
// NINGÚN CAMBIO DE SERVICE WORKER RECARGA LA PÁGINA POR SÍ SOLO (11-oct-2026).
// Antes, al cambiar de controlador (`controllerchange`) se recargaba a ciegas: sin
// mirar si había algo sin guardar, y también UNA VEZ EN LA PRIMERA VISITA (el
// primer service worker toma control con `clients.claim`). Ahora un service
// worker nuevo se queda ESPERANDO y lo atiende la franja de versión
// (FranjaVersionNueva en App.tsx): "Actualizar", o la recarga forzada solo si la
// versión mínima lo exige, con el mismo guardián y la misma espera de checada.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // SW no disponible: la app sigue funcionando normal.
    });
  });
}
